export default {"src":"/_next/static/media/safety-by-cilia-heart.a4986160.svg","height":113,"width":112,"blurWidth":0,"blurHeight":0};